<h1 mat-dialog-title>Seleziona la nave</h1>

<div mat-dialog-content>
  <p>Per quale nave vuoi effettuare la prenotazione?</p>
  <mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>Seleziona una nave</mat-label>
    <mat-select [(ngModel)]="selectedShipId" name="ship">
      @for (ship of data.ships; track ship.id_ship) {
        <mat-option [value]="ship.id_ship">
          {{ ship.ship_name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div mat-dialog-actions>
    <button mat-button (click)="onCancel()">Annulla</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="selectedShipId" [disabled]="!selectedShipId">
      Conferma
    </button>
  </div>
</div>


